import fr from 'apexcharts/dist/locales/fr.json';
import en from 'apexcharts/dist/locales/en.json';
import es from 'apexcharts/dist/locales/es.json';
import ua from 'apexcharts/dist/locales/ua.json';
import pl from 'apexcharts/dist/locales/pl.json';
import ro from '@lib/locales/ro/apexcharts.json';

export function getApexchartsLocales(locale = 'fr') {
  let preparedLocale = locale;
  if (locale === 'uk') {
    preparedLocale = 'ua';
  }
  return {
    locales: [en, fr, es, ua, pl, ro],
    defaultLocale: preparedLocale,
  };
}
